import { useTranslation } from "react-i18next";
import SectionHeader from "../common/SectionHeader";
import LandingProductCard from "./LandingProductCard";
import { getLandingProducts } from "../../utils/landingAcf";
import { SECTION_CONTAINER } from "../../utils/layout";

function LandingProducts({ acf, resolveMedia }) {
  const { t } = useTranslation();
  const products = getLandingProducts(acf);

  if (products.length === 0) return null;

  return (
    <section className="caf-section caf-section--light">
      <div className="caf-section__block caf-section--elevated caf-section--elevated-tight caf-page-section">
        <SectionHeader
          title={t("Products")}
          subtitle={t(
            "Explore our premium sports flooring options at Caf Sports, designed for superior performance and safety. Contact us today for customized solutions and expert guidance",
          )}
          showAccent
          titleId="landing-products-title"
        />
        <div className={`${SECTION_CONTAINER} caf-page-section__body pb-8`}>
          <div className="caf-product-grid" aria-labelledby="landing-products-title">
            {products.map((product) => (
              <LandingProductCard
                key={product.id}
                product={product}
                image={resolveMedia(product.imageId)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default LandingProducts;
